import React, { useContext, useEffect, useState } from "react";
import { Title } from "../../../../../../stories/Title/Title";
import Close from "../../../../../../images/Close.svg";
import { Button } from "../../../../../../stories/Button/Button";
import { CustomModalStyles } from "../../../../../../styles/CustomModalStyles";
import { Operation } from "../../../../../../utils/Enum.types";
import BasicDetails from "../add/BasicDetails";
import RequiredDetails from "../add/RequiredDetails";
import { AppContext } from "../../../../../../context/context";
import { payloadTypes } from "../../../../../../context/reducer";
import { CustomModal } from "../../../../../../utils/UtilFunctions";
import { SupplierFormDetails } from "../../../../../../utils/formTypes";
import { GetSupplierByNodeId } from "../queries/queries";
import { useLazyQuery } from "@apollo/client";
import { AtsAcLdgr } from "../queries/types";
import { nodeVar } from "../../../../../../utils/commonQueryTypes";

interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}

const Index = ({ setModalFlag }: Props) => {
  const [basicDetails, setBasicDetails] = useState(false);
  const [requiredDetails, setRequiredDetails] = useState(false);
  const { dispatch } = useContext(AppContext);
  const { state } = useContext(AppContext);



  const initialValues: SupplierFormDetails = {
    supplier_name: "",
    address: "",
    city: "",
    state: "",
    pin: "",
    country: "",
    phone: "",
    email: "",
    multi_location: false,
    contactPerson: "",
    contactPersonAddress: "",
    contactPersonState: "",
    contactPersonCity: "",
    contactPersonPin: "",
    contactPersonCountry: "",
    contactPersonMobile: "",
    contactPersonEmail: "",
    contactPersonAadhar: "",
  };

  const [GetSupplier] = useLazyQuery<{ node: AtsAcLdgr }, nodeVar>(
    GetSupplierByNodeId
  );

  const [formData, setFormData] = useState<SupplierFormDetails>(initialValues);

  useEffect(() => {
    if (state.supplierId) {
      GetSupplier({
        variables: {
          id: state.supplierId,
          
        },
      }).then(({ data }) => {
        if (data && data.node)
          setFormData({
            supplier_name: data.node.desc,
            address: data.node.supplier_details.address,
            city: data.node.supplier_details.city,
            state: data.node.supplier_details.state,
            pin: data.node.supplier_details.pin,
            country: data.node.supplier_details.country,
            phone: data.node.supplier_details.phone,
            email: data.node.supplier_details.email,
            multi_location: data.node.multiLocation,
            contactPerson: data.node.supplier_details.contactPerson,
            contactPersonAddress:
              data.node.supplier_details.contactPersonAddress,
            contactPersonState:
              data.node.supplier_details.contactPersonState,
            contactPersonCity: data.node.supplier_details.contactPersonCity,
            contactPersonPin: data.node.supplier_details.contactPersonPin,
            contactPersonCountry:
              data.node.supplier_details.contactPersonCountry,
            contactPersonMobile:
              data.node.supplier_details.contactPersonMobile,
            contactPersonEmail:
              data.node.supplier_details.contactPersonEmail,
            contactPersonAadhar:
              data.node.supplier_details.contactPersonAadhar,
          });
      });
    }
  }, [GetSupplier, state.supplierId]);

  return (
    <>
      <div className="supplier__edit">
        <div className="supplier__edit--title">
          <Title variant="subtitle1">Choose a Section to Edit</Title>
          <img
            src={Close}
            alt=""
            onClick={() => {
              dispatch({
                type: payloadTypes.SET_SUPPLIER_ID,
                payload: {
                  supplierId: 0,
                },
              });
              setModalFlag(false);
            }}
          />
        </div>
        <div className="supplier__edit--tabs">
          <button onClick={() => setBasicDetails(!basicDetails)}>
            Basic Details
          </button>
          <button onClick={() => setRequiredDetails(!requiredDetails)}>
            Required Details
          </button>
        </div>
        <Button
          mode="cancel"
          onClick={() => {
            dispatch({
              type: payloadTypes.SET_SUPPLIER_ID,
              payload: {
                supplierId: 0,
              },
            });
            setModalFlag(false);
          }}
        />
      </div>
      <CustomModal
        isOpen={basicDetails}
        onRequestClose={() => setBasicDetails(!basicDetails)}
        contentComponent={
          <BasicDetails
            setModalFlag={setBasicDetails}
            operation={Operation.UPDATE}
            step={1}
          />
        }
        style={CustomModalStyles}
      />
      <CustomModal
        isOpen={requiredDetails}
        onRequestClose={() => setRequiredDetails(!requiredDetails)}
        contentComponent={
          <RequiredDetails
            setModalFlag={setRequiredDetails}
            operation={Operation.UPDATE}
            step={1}
          />
        }
        style={CustomModalStyles}
      />
    </>
  );
};

export default Index;
